import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfirmationModal } from "@air/component-confirmation-modal";
import { matchesAirror, UNAUTHORIZED_INACTIVE_OBJECT_ACTION } from "@air/errors";
import { useToasts } from "@air/provider-toast";
import { resetSelectedItemsAction } from "@air/redux-selected-items";
import pluralize from "pluralize";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useShowSubscriptionExpiredModal } from "~/hooks/useShowSubscriptionExpiredModal";
import { useDeletePrivateClips } from "~/swr-hooks/clips/useDeletePrivateClips";
import { DeleteAssetMessageModal } from "./DeleteAssetMessageModal";
export const DeletePrivateClipsModal = (param)=>{
    let { assetIds, onClose, onDelete, parentBoardId, trackLocation } = param;
    const dispatch = useDispatch();
    const [deleting, setDeleting] = useState(false);
    const { deletePrivateClips } = useDeletePrivateClips();
    const { showingSubscriptionExpiredModal } = useShowSubscriptionExpiredModal({
        onClose
    });
    const [deleteAssetModalProps, setDeleteAssetModalProps] = useState(null);
    const { showToast } = useToasts();
    if (showingSubscriptionExpiredModal) {
        return null;
    }
    const deleteClips = async ()=>{
        try {
            setDeleting(true);
            const deletePrivateClipsResult = await deletePrivateClips({
                assetIds,
                trackLocation,
                parentBoardId
            });
            setDeleting(false);
            onDelete === null || onDelete === void 0 ? void 0 : onDelete();
            if (deletePrivateClipsResult.ignoredAssetIds.length || deletePrivateClipsResult.removedAssetIds.length) {
                setDeleteAssetModalProps({
                    ...deletePrivateClipsResult,
                    onClose: ()=>{
                        setDeleteAssetModalProps(null);
                        onClose();
                    }
                });
            } else {
                dispatch(resetSelectedItemsAction());
                onClose();
            }
        } catch (error) {
            if (matchesAirror(error, UNAUTHORIZED_INACTIVE_OBJECT_ACTION)) {
                showToast("One or more items were already deleted.");
            } else {
                showToast("There was an error. Please try again later.");
            }
            setDeleting(false);
        }
    };
    if (deleteAssetModalProps) {
        return /*#__PURE__*/ _jsx(DeleteAssetMessageModal, {
            ...deleteAssetModalProps
        });
    }
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        ctaPrimaryText: "Delete",
        description: /*#__PURE__*/ _jsxs("p", {
            className: "text-14",
            children: [
                "Deleting ",
                pluralize("this", assetIds.length),
                " ",
                pluralize("asset", assetIds.length),
                " will also delete all of its versions from all locations for everyone in your workspace."
            ]
        }),
        id: "delete-private-clips",
        isDangerous: true,
        isLoading: deleting,
        isOpen: true,
        onConfirm: deleteClips,
        onDismiss: onClose,
        title: "Delete ".concat(pluralize("asset", assetIds.length, true), "?")
    });
};
